module.exports = __webpack_public_path__ + "59059873060fcb21eee6c2a5f0d30840.jpg";